// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"ebdc01c9","725":"a73de18b"}[chunkId] + ".chunk.css";
};